import { Injectable } from '@angular/core';
import { LocalApiClientService } from './local-api-client.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Injectable({
  providedIn: 'root'
})
export class LocalApiConnectorService extends LocalApiClientService {

  constructor(private loader: NgxUiLoaderService) {
    super();
    this.InitLocalApiClient(0)
  }
  isMobile() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      return true;
    }
    else {
      return false;
    }
  }
  getScanners(sucFun) {
    this.ExecuteLocalApi("GetScanners", null, null, null, (res) => {
      return sucFun(res)
    });
  }

  getPrinters(sucFun,errFun) {
    this.ExecuteLocalApi("GetPrinters", null, null, null, (res) => {
      return sucFun(res)
    }, () => { return errFun() });
  }
  startScaning(sucFun, param) {
    this.ExecuteLocalApi("StartScaning.Start", null, null, param, (res) => {
      return sucFun(res)
    });
  }
  getScanningResult(sucFun) {
    this.ExecuteLocalApi("StartScaning.GetResult", null, null, null, (res) => {
      return sucFun(res)
    });
  }
  print(sucFun, errFun, param) {
    if (!this.isMobile()) {
      this.ExecuteLocalApi("print", null, null, param, (res) => {
        console.log("print", res);
        console.log("print", param);
        return sucFun(res)
      }, () => {
        return errFun()
      });
    }
    else {
      return sucFun("")
    }
    
  }

}
